var _circle, _path, _path2, _path3, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColoredCompass = function SvgColoredCompass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.75,
    fill: "#fff",
    stroke: "#5A5A5A",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5A5A5A",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M16 2v4M16 26v4M2 16h4M26 16h4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F15D4F",
    d: "m13.1 16.003 2.69-8.54a.25.25 0 0 1 .478 0l2.64 8.534z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B6B9",
    d: "m18.905 15.997-2.692 8.54a.25.25 0 0 1-.477 0l-2.64-8.534z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.999,
    r: 1,
    fill: "#687074",
    transform: "rotate(45 16 15.999)"
  })));
};
export default SvgColoredCompass;